import script from "./VacancyDraftComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VacancyDraftComponent.vue?vue&type=script&setup=true&lang=js"

import "./VacancyDraftComponent.vue?vue&type=style&index=0&id=59fd9fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fd9fb0"]])

export default __exports__